export default "__VITE_ASSET__33e49bb6__"